import { SaleBadgeProps } from '../../types';
import { generateSalePercentageBasedOnType } from 'utils';
import pipaBadge from 'assets/Badges/pipa-badge.png';
import './style.scss';

export const PipaSaleBadge = ({
  salePercentage,
  salePercentageDisplayType,
}: SaleBadgeProps) => {
  return (
    <div className="pipa-sale-badge">
      <img src={pipaBadge} alt="sale-badge" className="pipa-sale-badge__img" />
      <span className="pipa-sale-badge__number">
        {generateSalePercentageBasedOnType(
          salePercentage,
          salePercentageDisplayType,
        )}{' '}
        More
      </span>
    </div>
  );
};
